import { ClinksStatusOption } from '../../../utils/types';

export const CLINKS_STATUS_OPTIONS: ClinksStatusOption[] = [
  // Products with cLinks
  { id: 'APP_HAS_CLINKS', name: 'Only products with cLinks', category: 'app' },
  { id: 'APP_NO_CLINKS', name: 'Only products with no cLinks', category: 'app' },
  
  // Campaigns with cLinks
  { id: 'CAMPAIGN_HAS_CLINKS', name: 'Only campaigns with cLinks', category: 'campaign' },
  { id: 'CAMPAIGN_NO_CLINKS', name: 'Only campaigns with no cLinks', category: 'campaign' }
];

export default CLINKS_STATUS_OPTIONS;